import * as React from "react";
import { toast } from "react-toastify";
import Stripe from "stripe";

import { IframeModal } from "src/library/components/Modal";
import { PaymentTransaction } from "src/modules/payment/api/transactions.api";

import { StripeThreeDSecureEventAttributes } from "../api/transactions.api";

interface ThreeDSecureModalProps {
  handleError: (transaction: PaymentTransaction | null, stripeError?: Stripe.StripeRawError) => void;
  secureUrl: string | null;
  onSuccess: (transaction: PaymentTransaction | null, paymentIntent?: Stripe.PaymentIntent) => void;
}
export const ThreeDSecureModal: React.ReactFCWithChildren<ThreeDSecureModalProps> = ({
  handleError, onSuccess, secureUrl
}) => {
  /**
   * Handle 3D secure completion
   */
  const handleThreeDSecureCompletion = React.useCallback((event: MessageEvent<Partial<StripeThreeDSecureEventAttributes>>) => {
    const evt = event.data;

    // Close the 3D secure modal on completion
    // not sure if this is needed anymore (old 3d secure but keep in JIC)
    if (evt.type === "stripe-3ds-result") {
      const data = evt.message as StripeThreeDSecureEventAttributes["message"];

      // If an error occurs, show the error message
      if (data.stripeError) {
        // Update the orderPaymentError state
        handleError(null, data.stripeError);
      }

      // On successful completion, refresh the order data
      if (data.payment_intent) {
        // Inform the user of the success
        toast.success("The payment was successfully authorized.");
        // Inform the backend to resync the order's latest transaction
        onSuccess(null, data.payment_intent);
      }

      // Update the threeDSecureModal
    } else if (evt.type === "3DS-authentication-complete" && evt.message?.transaction) {
      onSuccess(evt.message?.transaction);
    } else if (evt.type === "3DS-authentication-error" && evt.message?.transaction) {
      handleError(evt.message?.transaction);
    }
  }, [ handleError, onSuccess ]);

  // On mount
  React.useEffect(() => {
    // Add a message event listener for a "3DS-authentication-complete" even
    window.addEventListener("message", handleThreeDSecureCompletion, false);

    return () => {
      window.removeEventListener("message", handleThreeDSecureCompletion);
    };
  }, [ handleThreeDSecureCompletion ]);

  return (
    <>
      <IframeModal
        show={!!secureUrl}
        onDismiss={() => {
          // dont allow dismiss!
        }}
        url={secureUrl}
      />

    </>
  );
};
